import { useEffect } from 'react';

type BackCallback = (...args: any) => void;

class BackManagerClass {
  private callback: BackCallback | null = null;
  private enabled = false;

  constructor() {
    window.addEventListener('popstate', this.handler);
  }

  private handler = (event: PopStateEvent) => {
    if (!this.enabled) {
      return;
    }

    event.preventDefault();

    if (this.callback) {
      this.callback();
    }

    window.history.pushState(null, '', window.location.pathname);
  };

  set(callback: BackCallback) {
    this.callback = callback;
    this.enabled = true;

    window.history.pushState(null, '', window.location.pathname);
  }

  clear() {
    this.enabled = false;
    this.callback = null;
  }
}

export const BackManager = new BackManagerClass();

export const useCallBackOnBack = (callback: BackCallback = () => {}, enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    BackManager.set(callback);

    return () => {
      BackManager.clear();
    };
  }, [enabled]);
};
